import { Form, Input, FormContext } from 'dash-ui';
import { type ChangeEvent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFields } from 'containers/properties/PropertyInventory/components/AddPropertyInventoryModal/constants/constants';
import useValidation from 'containers/properties/PropertyInventory/components/AddPropertyInventoryModal/hooks/useValidation';

const NameRow = () => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formState, formErrors, stateHandlers } = useContext(FormContext);
  const valid = useValidation();

  const onChange =
    (fieldName: FormFields) => (e: ChangeEvent<HTMLInputElement>) => {
      stateHandlers[fieldName](e.target.value);
      valid(fieldName, e.target.value);
    };

  return (
    <Form.Group w="100%" mt={3}>
      <Form.Label required>{t('forms:labels.name')}</Form.Label>
      <Input
        w="100%"
        value={formState.name || ''}
        placeholder={t('forms:placeholders.inventoryName') || ''}
        onChange={onChange(FormFields.Name)}
        $errorType={formErrors[FormFields.Name]?.type}
      />
      <Form.Feedback $errorType={formErrors[FormFields.Name]?.type}>
        {formErrors[FormFields.Name]?.message}
      </Form.Feedback>
    </Form.Group>
  );
};

export default NameRow;
